<forge-chip-set fxLayout="row" fxLayoutAlign="end center" readonly="true" type="action">
  @for (chip of chips; track chip) {
    @if (chip.isVisible) {
      <forge-chip (click)="chip.action($event)" telemetry="Submission-{{chip.label}}">
        {{chip.label}}
      </forge-chip>
    }
  }
</forge-chip-set>